import type { TMessages } from '@/types/TMessages'

export const messages = {
  title: 'Насколько понятным и полным для вас было описание условий финансирования?',
} as const satisfies TMessages
